/**
 * The Studio's home: the protocol library ("Your processes") under the app's
 * header. Full-screen the header carries the way back to the main app and its
 * navigation; in the main app's pane the main app's own header is already
 * there, so this one is left out.
 *
 * Design (DESIGN.md): flat hairline header (no shadow), Action Blue accents,
 * SF Pro / Inter type, tight clinical layout.
 */

import { MainAppNav, ReturnToMainAgent, isEmbedded, useBrandName } from '@ai4nr/tricorder-ui'
import { useTranslation } from 'react-i18next'

import { ManageList } from '../components/manage/ManageList'

export default function Home() {
  const { t } = useTranslation()
  const brand = useBrandName()

  return (
    <div className="flex h-dvh flex-col bg-[var(--color-surface-canvas,#ffffff)]">
      {!isEmbedded() && (
        <header className="border-b border-[var(--color-surface-border)] bg-[var(--color-surface-bg)]">
          <div className="mx-auto flex w-full max-w-7xl items-center gap-2 px-4 py-4 sm:px-6">
            <ReturnToMainAgent className="-ml-2" />
            <h1 className="text-[19px] font-semibold tracking-[-0.01em] text-[var(--color-surface-ink)]">
              {brand}
            </h1>
            <span className="text-[19px] font-normal text-[var(--color-surface-mute)]">
              {t('alg.protocols', 'Protocols')}
            </span>
            <MainAppNav className="ml-auto" />
          </div>
        </header>
      )}

      <main className="min-h-0 flex-1 overflow-auto">
        <ManageList />
      </main>
    </div>
  )
}
